import { Box, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "4rem",
        width: "100vw",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.75rem",
        }}
      >
        &copy; Copyright {currentYear} Advanced Compliance Technology Ltd
      </Typography>
    </Box>
  );
};

export default Footer;
